import {useReducer} from 'react'

export function useReducers(config) {
  let reducers = {}
  let dispatchs = {}

  for (const name in config) {
    const [state, dispatch] = useReducer(config[name], {})

    reducers = {...reducers, [name]: state}
    dispatchs = {...dispatchs, [name]: dispatch}
  }

  return {reducers, dispatchs}
}
